$(document).ready(function() {
	$(".two-column-slider").slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		// appendDots: $(".slider-dots"),
	});

	$(".img_text_content").slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
	});

	$(window).width() < 991 && $(".custom_collection .grid").slick({
		dots: !1,
		arrows: !1,
		infinite: !1,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
                    arrows: true,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
                    arrows: true
				}
			},
            {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
                    arrows: true
				}
			}

		]
	});

    // Text Slider With Image Section

    $(".text_slider_with_image .content_wrapper").slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
    });

    $(".only_text_slider .only_text_slide_items").slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

});

const interval = setInterval(() => {
  const component = document.querySelector('shopify-accelerated-checkout');

  // Ensure the component and its shadow root exist
  if (component && component.shadowRoot) {
    const button = component.shadowRoot.querySelector('.gravity-button');
    if (button) {
      // Apply inline styles
      Object.assign(button.style, {
        minHeight: '67px',
        fontSize: '22px',
        textTransform: 'uppercase',
        fontWeight: '300',
        color: '#FFFFFF',
        lineHeight: '1',
        border: '0',
        width: 'auto',
        minWidth: '273px',
        boxShadow: '0px 4px 4px 0px #00000040',
        fontFamily: "'Kanit', sans-serif"
      });

      console.log('Styles applied to .gravity-button');
      clearInterval(interval); // stop once applied
    }
  }
}, 200); // check every 200ms
